// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2277":"2b0c840d","2448":"2b0c840d","3698":"2b0c840d","4382":"2b0c840d","4730":"2b0c840d","6269":"2b0c840d","6471":"2b0c840d","7068":"2b0c840d","7616":"2b0c840d","8942":"2b0c840d"}[chunkId] + ".chunk.css";
};